import { Component, Input } from '@angular/core';

import { LanguageService } from '../../../_services/index';

@Component({
    selector: 'richtxt-editor',
    template: `
  <nb-card *ngIf="model">
    <nb-card-header>
      <div class="d-flex">
        <span>{{label}}</span>
      </div>
      <nb-toggle status="info" [(ngModel)]="isRawEdit">Raw editor</nb-toggle>
    </nb-card-header>

    
    <quill-editor class="h-60" [(ngModel)]="model[languageService.currentLang]" [ngModelOptions]="{standalone: true}" 
      [sanitize]="false" *ngIf="!isRawEdit" (onEditorCreated)="onEditorCreated($event)"></quill-editor>

    <textarea *ngIf="isRawEdit" nbInput fullWidth [placeholder]="label" class="form-control bg-white" rows="12" [(ngModel)]="model[languageService.currentLang]" [ngModelOptions]="{standalone: true}"></textarea>
    
  </nb-card>
  `,
    standalone: false
})

export class QuillEditorComponent {

  constructor(public languageService: LanguageService) {  
  }

  @Input() label;
  @Input() model;

  isHtmlEdit = true;
  isRawEdit = false;

  onEditorCreated(quill) {
    quill.legacyGetSemanticHTML = quill.getSemanticHTML;
    quill.getSemanticHTML = (a: number, b: number) =>
      quill
        .legacyGetSemanticHTML(a, b)
        .replaceAll(/((?:&nbsp;)*)&nbsp;/g, '$1 ');
  }
}
